import React, { useState, useCallback, useEffect } from 'react';
import GridLayout, { Responsive, WidthProvider } from "react-grid-layout";
import { DashboardWidget } from '../DashboardWidget';
import useWindowDimensions from "../../hooks/useWindowDimensions";

const ResponsiveGridLayout = WidthProvider(Responsive);

export const Dashboard = (props) => {
 
  //const [widgets, setWidgets] = useState(localStorage.getItem("ciklopark_nationaldb_widget_layout") && JSON.parse(localStorage.getItem("ciklopark_nationaldb_widget_layout")) || props.widgets);
  const [widgets, setWidgets] = useState(props.widgets);
  const [bp, setBp] = useState('')

  const onLayoutChange = useCallback(
		(_, oldItem, newItem) => {
			const newWidgetArr = [...widgets];
			newWidgetArr.forEach((x) => {
				if (x.id === oldItem.i) {
					x.layout = newItem;
				}

			});
			setWidgets(newWidgetArr);
		},
		[widgets]
	);

	const onDrop = useCallback(
		(_, item, e) => {
			const raw = e.dataTransfer?.getData('droppableWidget');
			if (!raw) {
				return;
			}

			const droppableWidget = JSON.parse(raw);

			const newWidgetArr = [...widgets];

			droppableWidget.layout.x = item.x;
			droppableWidget.layout.y = item.y;
			droppableWidget.layout.isDraggable = false;
			newWidgetArr.push(droppableWidget);

			setWidgets(newWidgetArr);
		},
		[widgets],
	);

	useEffect(() => {
		//localStorage.setItem("ciklopark_nationaldb_widget_layout", JSON.stringify(widgets))


		// Add any logic here to presist widgets and their layout to any presistent storage, like localStorage or any API
	}, [widgets]);

  	return (props.isPrinting && (
		widgets.filter(w => w.visible).map(x => (
			<DashboardWidget layers={props.layers} isPrinting={props.isPrinting} search_params={props.search_params} key={x.id} component={x.component} data-grid={x.layout} 
			answer_name={x.answer_name}
			survey_id={x.survey_id}
			answer_title={x.answer_title} 
			analytic_url={x.analytic_url}
			//used for AnalyticDonutGraph and AnalyticStackedBarGraph
			survey_title_key={x.survey_title_key}
			survey_value_key={x.survey_value_key}
			stacked_horizontal_chart_y_axis={x.stacked_horizontal_chart_y_axis}
			//
			//used for AnalyticDonutGraphWithFilter
			filter_key={x.filter_key}
			mapped_key={x.mapped_key}
			filter_elements={x.filter_elements}
			//
			//used for AnalyticStackedBrGraph
			offset_x={x.offset_x}
            offset_y={x.offset_y}
            max_width={x.max_width}
			//
			/>
		
		))
	) || (
 <ResponsiveGridLayout
			autoSize
			key={bp}
			onBreakpointChange={setBp}
			allowOverlap={false}
			preventCollision={false}
			useCSSTransforms
			isDroppable
			isResizable
			draggableCancel={".not-draggable"}
			compactType={null}
			breakpoints={{ lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 }}
			cols={{ lg: 12, md: 10, sm: 6, xs: 4, xxs: 2 }}
			onLayoutChange={onLayoutChange}
			onDrop={onDrop}
			onDragStop={onLayoutChange}
			onResizeStop={onLayoutChange}
			//onWidthChange={handleWidthChange}
			resizeHandles={['se']}
		
		>
			{widgets.filter(w => w.visible).map(x => (
				<DashboardWidget layers={props.layers} isPrinting={props.isPrinting} search_params={props.search_params} key={x.id} component={x.component} data-grid={x.layout} 
				answer_name={x.answer_name}
				survey_id={x.survey_id}
				answer_title={x.answer_title}
				analytic_url={x.analytic_url}
				survey_title_key={x.survey_title_key}
				survey_value_key={x.survey_value_key}				
				stacked_horizontal_chart_y_axis={x.stacked_horizontal_chart_y_axis} 
				filter_key={x.filter_key}
				mapped_key={x.mapped_key}
				filter_elements={x.filter_elements}
				offset_x={x.offset_x}
            	offset_y={x.offset_y}
            	max_width={x.max_width}
				/>
			
			))}
		</ResponsiveGridLayout> 
	)
		
		
  	);
};